import InutilizacaoNFCeService from "@/services/InutilizacaoNFCeService";

export const inutilizacaoNFCe = {
  namespaced: true,
  state: {
    inutilizacaoNFCe: {},
  },
  actions: {
    getInutilizacaoNFCe({ commit }, payload) {
      return InutilizacaoNFCeService.GetInutilizacaoNFCe(payload).then(
        (inutilizacaoNFCe) => {
          return Promise.resolve(inutilizacaoNFCe);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postInutilizacaoNFCe({ commit }, payload) {
      return InutilizacaoNFCeService.PostInutilizacaoNFCe(payload).then(
        (inutilizacaoNFCe) => {
          return Promise.resolve(inutilizacaoNFCe);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putInutilizacaoNFCe({ commit }, payload) {
      return InutilizacaoNFCeService.PutInutilizacaoNFCe(payload).then(
        (inutilizacaoNFCe) => {
          return Promise.resolve(inutilizacaoNFCe);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteInutilizacaoNFCe({ commit }, payload) {
      return InutilizacaoNFCeService.DeleteInutilizacaoNFCe(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getInutilizacaoNFCeOData({ commit }, payload) {
      return InutilizacaoNFCeService.GetInutilizacaoNFCeOData(payload).then(
        (inutilizacaoNFCe) => {
          return Promise.resolve(inutilizacaoNFCe);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default inutilizacaoNFCe;
